import React from 'react';
import type {
  TaskAssignmentResponse,
  TaskDefinitionResponse,
} from 'src/api/ProactApiClient';
import {TaskTypeEnum} from 'src/api/ProactApiClient';
import {
  ApprovalAssignmentView,
  ApprovalDefinitionView,
} from 'src/app/approvals/ApprovalViews';
import {
  AssignedFormAssignmentView,
  AssignedFormDefinitionView,
} from 'src/app/assigned-forms/AssignedFormViews';
import {
  ToolboxTalkAssignmentView,
  ToolboxTalkDefinitionView,
} from 'src/app/toolbox-talks/ToolboxTalkViews';

export const TaskFeatureDefinitionView: React.FC<{
  item: TaskDefinitionResponse;
}> = ({item}) => {
  switch (item.taskType) {
    case TaskTypeEnum.ToolboxTalk:
      return <ToolboxTalkDefinitionView item={item} />;
    case TaskTypeEnum.Form:
      return <AssignedFormDefinitionView item={item} />;
    case TaskTypeEnum.Approval:
      return <ApprovalDefinitionView item={item} />;
    default:
      return null;
  }
};

export const TaskFeatureAssignmentView: React.FC<{
  item: TaskAssignmentResponse;
}> = ({item}) => {
  switch (item.taskDefinition.taskType) {
    case TaskTypeEnum.ToolboxTalk:
      return <ToolboxTalkAssignmentView item={item} />;
    case TaskTypeEnum.Form:
      return <AssignedFormAssignmentView item={item} />;
    case TaskTypeEnum.Approval:
      return <ApprovalAssignmentView item={item} />;
    default:
      return null;
  }
};
